import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlighted',
})
export class HighlightedPipe implements PipeTransform {
  private arr: any;
  private arr2: any;

  transform(value1: any, value2: any, val3: any): any {
    switch (val3) {
      case 'task_entities': {
        value1.map((x) => {
          this.arr = x.entity_id;
        });
        value2.map((x) => {
          this.arr2 = x.entity_id;
        });
        return JSON.stringify(this.arr) !== JSON.stringify(this.arr2);
        break;
      }
      case 'normal_case': {
        return JSON.stringify(value1) !== JSON.stringify(value2);
        break;
      }
      case 'assign': {
        value1.map((x) => {
          this.arr = x.responsible_id;
        });
        value2.map((x) => {
          this.arr2 = x.responsible_id;
        });
        return JSON.stringify(this.arr) !== JSON.stringify(this.arr2);
        break;
      }
      case 'attachments': {
        value1.map((x) => {
          this.arr = x.url;
        });
        value2.map((x) => {
          this.arr2 = x.url;
        });
        return JSON.stringify(this.arr) !== JSON.stringify(this.arr2);
        break;
      }
      case 'follower': {
        value1.map((x) => {
          this.arr = x.follower_id;
        });
        value2.map((x) => {
          this.arr2 = x.follower_id;
        });
        return JSON.stringify(this.arr) !== JSON.stringify(this.arr2);
        break;
      }
    }
  }
}
